const ResponseBaseStatus = {
  ERROR_APLICACION: -1,
  ERROR_NEGOCIO: 0,
  OK: 1,
};

export default ResponseBaseStatus;
